// extracted by mini-css-extract-plugin
module.exports = {"container":"RichTextSection_container__c7_cS","header":"RichTextSection_header__InANL","wrapper":"RichTextSection_wrapper__VDKXN"};